import { useAppSelector } from '../app/hooks';
import { UPGRADE, UPGRADE_PREFIX, UPSELL, UPSELL_PREFIX } from '../constants';
import {
  selectIsAIEscalatedOnCarEnter,
  selectIsAIEscalation,
} from '../redux/features/ai/ai.selector';
import { selectAIEscalationUpsell } from '../redux/features/config/config.selector';
import { ParsedMenuItem } from '../types/menu';
import { TopLevelMenuItem } from '../utils/menu';

const useAIEscalationUpsell = () => {
  const isAIEscalation = useAppSelector(selectIsAIEscalation);
  const isUpsellAllowed = useAppSelector(selectAIEscalationUpsell);
  const isAIEscalatedOnCarEnter = useAppSelector(selectIsAIEscalatedOnCarEnter);

  const canUpsellInAIEscalation = (
    menuItem: ParsedMenuItem | TopLevelMenuItem
  ) =>
    !!(
      isAIEscalation &&
      !isUpsellAllowed &&
      !isAIEscalatedOnCarEnter &&
      (menuItem?.name?.startsWith(UPSELL) ||
        menuItem?.name?.startsWith(UPSELL_PREFIX) ||
        menuItem?.name.startsWith(UPGRADE) ||
        menuItem?.name.startsWith(UPGRADE_PREFIX))
    );

  return {
    canUpsellInAIEscalation,
  };
};

export default useAIEscalationUpsell;
